<template>
  <div class="my-8">
    <app-heading
      :text="'Banner Announcements'"
      :heading="'main'"
    ></app-heading>
    <ag-grid-vue
      class="ag-theme-alpine mt-6"
      style="width: 100%; height: 40vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="announcements"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="announcementData.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>
    <app-heading
      :text="announcementTitle"
      :heading="'title'"
      class="mt-10"
    ></app-heading>
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="latestAnnouncement"
          label="Enter new announcement"
          rows="4"
          outlined
          clearable
          width="100%"
          no-resize
          hide-details
        ></v-textarea>
      </v-col>
      <v-col cols="12" class="d-flex align-center justify-end">
        <v-btn
          v-if="!isEditingAnnouncement"
          class="primary"
          @click="addAnnouncement('new')"
          >Save</v-btn>
        <v-btn
          v-if="isEditingAnnouncement"
          class="primary"
          @click="updateAnnouncement({type: 'editText', data: { announcementText: latestAnnouncement}})"
          >Update</v-btn>
        <v-btn
          v-if="isEditingAnnouncement"
          class="primary ml-3"
          @click="resetValue()"
          >Cancel</v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
// import TableActions from "@/components/common/nbn-table-actions";
import { AgGridVue } from "ag-grid-vue";
import {formatDateTime} from "@/plugins/global-functions";
import AnnouncementsTableActions from "@/components/common/announcements-table-actions.vue";
export default {
  name: "NbnOrderManagement",
  components: { AgGridVue, AnnouncementsTableActions },
  data: () => ({
    latestAnnouncement: "",
    latestId: 0,
    columnDefs: null,
    gridOptions: {},
    announcementData: {},
    items: [],
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: ""
    },
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true
    },
    deleted: "Deleted announcement - no announcement to display",
    page: 1,
    isEditingAnnouncement: false
  }),
  beforeMount() {
    let vm = this;
    vm.gridOptions = {
      frameworkComponents: {
        tableRenderer: AnnouncementsTableActions
      },
    }
    vm.columnDefs = [
      {
        headerName: 'ID',
        editable: false,
        field: 'id',
        width: 100
      },
      {
        headerName: 'Announcement',
        editable: false,
        field: 'announcementText',
        width: 775
      },
      {
        headerName: 'Updated by',
        editable: false,
        field: 'updatedBy',
        width: 300
      },
      {
        headerName: 'Date & Time',
        editable: false,
        field: 'updatedDateTime',
        sort: 'desc',
        width: 250,
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: 'Actions',
        field: 'actions',
        editable: false,
        sort: 'desc',
        width: 200,
        cellRenderer: 'tableRenderer'
      },
    ];
    vm.defaultColDef = {
      autoHeight: true
    };
    vm.getAnnouncements();
  },
  methods: {
    paginationChange(val) {
      let vm = this;
      vm.paging.pageNo = val;
      vm.getAnnouncements(vm.user.email);
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      vm.gridApi.addEventListener('toggle', vm.updateAnnouncement);
      vm.gridApi.addEventListener('archive', vm.updateAnnouncement);
      vm.gridApi.addEventListener('restore', vm.updateAnnouncement);
      vm.gridApi.addEventListener('editText', vm.editAnnouncementText);
    },
    updateAnnouncement(payload){
      let vm = this;
      let announcement = null;
      if(payload.type === "editText") {
        announcement = {
          type: payload.type,
          data: {
            announcementText: vm.latestAnnouncement,
            id: vm.latestId
          }
        }
      } else announcement = payload;
      vm.upsertAnnouncement(announcement).then(() => {
        vm.isEditingAnnouncement = false;
        window.location.reload();
      })
    },
    addAnnouncement(){
      let vm = this;
      
      let payload = {
        type: "add",
        data: {
          announcementText: vm.latestAnnouncement
        }
      }
      vm.upsertAnnouncement(payload).then(() => {
        window.location.reload();
      })
    },
    editAnnouncementText(payload){
      let vm = this;
      vm.isEditingAnnouncement = true;
      vm.latestAnnouncement = payload.data.announcementText;
      vm.latestId = payload.data.id;
    },
    resetValue(){
      let vm = this;
      vm.isEditingAnnouncement = false;
      vm.latestAnnouncement = "";
      vm.latestId = 0;
    }
  },
  computed:{
    announcementTitle(){
      let vm = this;
      return vm.isEditingAnnouncement ? "Update Announcement" : "Add New Announcement";
    }
  }
}
</script>
<style lang="scss" scoped>
</style>